module.exports = __webpack_public_path__ + "static/media/destination_shortlist.036a2a9d.png";